import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTabs,_vm._g(_vm._b({staticClass:"v-tabs--pill",attrs:{"active-class":`${_vm.color} ${_vm.theme.isDark ? 'black' : 'white'}--text`,"hide-slider":""}},'v-tabs',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_vm._t("items")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }